var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-cascader',{attrs:{"value":_vm.value,"options":_vm.options,"props":{
    checkStrictly: _vm.checkStrictly || false,
    value: 'area_name',
    label: 'area_name',
    children: 'child',
  },"clearable":"","placeholder":_vm.placeholder},on:{"clear":function($event){return _vm.$emit('clear')},"change":_vm.changeValue}})
}
var staticRenderFns = []

export { render, staticRenderFns }